<!-- =========================================================================================
    File Name: NotAuthorized.vue
    Description: Not Authorized Page

========================================================================================== -->

<template>
	<div class="h-screen flex w-full bg-img">
		<div
			class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
		>
			<img
				src="@/assets/images/pages/not-authorized.png"
				alt="graphic-not-authorized"
				class="mx-auto mb-4"
			/>
			<h1
				class="sm:mx-0 mx-4 sm:mb-12 mb-8 text-5xl d-theme-heading-color"
			>BẠN KHÔNG CÓ QUYỀN TRUY CẬP!</h1>
			<p
				class="sm:mx-0 mx-4 sm:mb-12 mb-8 d-theme-text"
			>Chức năng bạn yêu cầu không tồn tại hoặc bạn chưa có quyền truy cập.</p>
			<vs-button size="large" to="/">{{$t('BackToHomepage')}}</vs-button>
			<vs-button class="mt-3" size="large" @click="logout">{{$t('Logout')}}</vs-button>
		</div>
	</div>
</template>

<script>
export default {
	methods: {
		async logout() {
			localStorage.removeItem("userInfo");
			await this.$router.push("/").catch();

			// If JWT login
			this.$store.dispatch("resetStore");
			if (localStorage.getItem("accessToken")) {
				localStorage.removeItem("accessToken");
				this.$router.push("/pages/login").catch(() => {});
			}

			// Change role on logout. Same value as initialRole of acj.js
			this.$acl.change("guest");

			// This is just for demo Purpose. If user clicks on logout -> redirect
			this.$router.push("/pages/login").catch(() => {});
		}
	}
};
</script>
